import {
  CfFtpInfoState,
  CfFtpInfoActionTypes,
  GET_CF_FTP_INFO_LIST,
  GET_CF_FTP_INFO_LIST_FULFILLED,
  GET_CF_FTP_INFO_PENDING,
  GET_CF_FTP_INFO_FULFILLED,
  SELECT_CF_FTP_INFO,
  CREATE_CF_FTP_INFO_PENDING,
  CREATE_CF_FTP_INFO_FULFILLED,
  DELETE_CF_FTP_INFO_FULFILLED,
  OPEN_CF_FTP_INFO_CREATE_POPUP,
  CLOSE_CF_FTP_INFO_CREATE_POPUP,
  SET_CF_FTP_INFO_LOADING,
} from './cfFtpInfo.types';

export const initialState: CfFtpInfoState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function cfFtpInfoReducer(
  state = initialState,
  action: CfFtpInfoActionTypes,
): CfFtpInfoState {
  switch (action.type) {
    case GET_CF_FTP_INFO_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_CF_FTP_INFO_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_CF_FTP_INFO_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_CF_FTP_INFO_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_CF_FTP_INFO:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_CF_FTP_INFO_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_CF_FTP_INFO_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_CF_FTP_INFO_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_CF_FTP_INFO_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

      case OPEN_CF_FTP_INFO_CREATE_POPUP:
        return {
          ...state,
          single: action.payload.cfFtpInfo ?? null,
          createdId: null,
          ui: {
            ...state.ui,
            isCreatePopupOpen: true,
          },
        };

      case CLOSE_CF_FTP_INFO_CREATE_POPUP:
        return {
          ...state,
          ui: {
            ...state.ui,
            isCreatePopupOpen: false,
          },
        };

    default:
      return state;
  }
}
